import { IEquipmentModel } from '../equipmentModels.types.ts'
import { useRecoilValue } from 'recoil'
import equipmentModelsAtom from '../equipmentModels.atom.ts'
import { useMemo } from 'react'

const useEquipmentModel = (id: IEquipmentModel['id']) => {
  const items = useRecoilValue(equipmentModelsAtom).items

  return useMemo(() => {
    return items.find((it) => it.id === id)
  }, [id, items])
}

export default useEquipmentModel
